import { FC } from "react";
import { CustomerAddActivityProps } from "./types";
import {
  ActivityBody,
  ActivityBodyInfo,
  ActivityBy,
  ActivityDate,
  ActivityFooter,
  ActivityTitle,
} from "../../components";
import { CustomerActivityAdd } from "../types";

const CustomerAddActivity: FC<CustomerAddActivityProps> = ({
  activity,
  type,
  by,
  date,
}) => {
  const _activity = activity as CustomerActivityAdd;
  return (
    <>
      <ActivityTitle type={type}>ثبت مشتری جدید</ActivityTitle>
      <ActivityBody>
        <ActivityBodyInfo
          type={type}
          title="نام مشتری"
          value={_activity.fullname}
        />
        <ActivityBodyInfo
          type={type}
          title="شماره تماس"
          value={_activity.phone}
        />
      </ActivityBody>
      <ActivityFooter>
        <ActivityBy>{by}</ActivityBy>
        <ActivityDate>{date}</ActivityDate>
      </ActivityFooter>
    </>
  );
};

export default CustomerAddActivity;
